import React from 'react';
import { Button, Table, Text } from 'components';
import OrderItem from '../OrderItem/OrderItem';
import MessageAlert, { openPopup, stringToMoneyFormat } from 'utils';
import Formatter from 'utils/Formatter';
import dayjs from 'dayjs';
import { Flex } from 'antd';

const PresentsListTable = ({
  orders = [],
  isSentOrders, // ✅ 선물한 내역 여부
  onExtension,
  onCancel,
}) => {
  const today = dayjs().unix();
  return (
    <React.Fragment>
      <Table
        data={orders}
        hovered={false}
        columns={[
          {
            key: 'orderDetails',

            render: (_, state) => {
              const representativeDate = Formatter.unixToDate(
                state.created_at,
                'YYYY.MM.DD'
              );

              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderTop: '2px solid var(--black-color)',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 20,
                      padding: '24px 0',
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        {/* 결제일 */}
                        <div style={{ width: '9.36%', textAlign: 'start' }}>
                          <Text style={{ fontSize: 16, fontWeight: 400 }}>
                            {representativeDate}
                          </Text>
                        </div>

                        {/* 상품 정보 */}
                        <div style={{ width: '25.4%' }}>
                          <OrderItem
                            src={state.product.thumbnail}
                            placeName={state.product.shop_information_name}
                            productName={state.product.product_name}
                            productData={
                              state.product.product_option
                                ? state.product.product_option
                                    .map((cur) =>
                                      cur.option
                                        .map((op) => op.option_name)
                                        .join(' / ')
                                    )
                                    .join(' / ')
                                : null
                            }
                          />
                        </div>

                        {/* sentOrders(선물한 내역)일 때만 금액 표시 */}
                        {
                          <Flex vertical>
                            <Text size={12} color={'#666666'}>
                              결제금액
                            </Text>
                            <Text size={18} weight={700}>
                              {stringToMoneyFormat(state.payment_price)}
                              <span>원</span>
                            </Text>
                          </Flex>
                        }
                        {!isSentOrders ? (
                          <Flex vertical>
                            <Text size={12} color={'#666666'}>
                              선물수량
                            </Text>
                            <Text size={18} weight={700}>
                              {stringToMoneyFormat(state.received_present)}
                              <span>개</span>
                            </Text>
                          </Flex>
                        ) : null}
                        {isSentOrders ? (
                          <Flex vertical>
                            <Text size={12} color={'#666666'}>
                              선물수량
                            </Text>
                            <Text size={18} weight={700}>
                              {stringToMoneyFormat(state.received_present)}
                              <span>개</span>
                            </Text>
                          </Flex>
                        ) : (
                          <Flex vertical align="center">
                            <Text size={16}>
                              {today > state.expired_date
                                ? '만료됨'
                                : state.received_present -
                                    state.used_present ===
                                  0
                                ? '사용완료'
                                : state.payment_state === 'CANCELLED'
                                ? '결제취소'
                                : '사용가능'}
                            </Text>

                            <Text size={12} color={'var(--light-gray-color)'}>
                              {today > state.expired_date
                                ? Formatter.unixToDate(
                                    state.expired_date,
                                    'YYYY.MM.DD HH:mm'
                                  )
                                : state.received_present -
                                    state.used_present ===
                                  0
                                ? Formatter.unixToDate(
                                    state.expired_date,
                                    'YYYY.MM.DD HH:mm'
                                  )
                                : '-'}
                            </Text>
                          </Flex>
                        )}

                        <Flex
                          vertical
                          align="center"
                          style={{ width: 230, overflow: 'hidden' }}
                        >
                          <Text size={16}>{state.message}</Text>

                          {/* sentOrders(선물한 내역)일 때만 message 표시 */}
                          {isSentOrders ? (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10,
                              }}
                            >
                              {/* ✅ order.message === '미발송'일 때 "발송하기" 버튼 추가 */}
                              {state.is_sent === 'N' ? (
                                <Button
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    padding: '4px 8px',
                                    cursor: 'pointer',
                                    backgroundColor: 'var(--black-color)',
                                    color: 'white',
                                    borderRadius: '4px',
                                  }}
                                  onClick={() =>
                                    MessageAlert.info(
                                      '메세지 전송에 실패하였습니다. 관리자에게 문의해주세요!'
                                    )
                                  }
                                >
                                  메세지 전송 실패
                                </Button>
                              ) : (
                                <Text size={14}>메세지 전송성공</Text>
                              )}
                            </div>
                          ) : (
                            // receivedOrders(선물 받은 내역)일 때만 연장하기 & 배송지 입력 버튼 표시
                            <div style={{ display: 'flex', gap: '8px' }}>
                              {state.extendable_count &&
                              state.received_present - state.used_present !==
                                0 &&
                              state.payment_state !== 'CANCELLED' ? (
                                <Button
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    padding: '4px 8px',
                                    cursor: 'pointer',
                                    border: 'none',
                                    backgroundColor: 'var(--black-color)',
                                    color: 'var(--white-color)',
                                    borderRadius: '2px',
                                  }}
                                  onClick={() => onExtension(state)}
                                >
                                  연장하기
                                </Button>
                              ) : null}

                              {state?.product?.type !== 'AMOUNT' ? (
                                <Button
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    padding: '4px 8px',
                                    cursor: 'pointer',
                                    border: '1px solid var(--black-color)',
                                    backgroundColor: 'var(--white-color)',
                                    color: 'var(--black-color)',
                                    borderRadius: '2px',
                                  }}
                                  onClick={() =>
                                    openPopup(
                                      `/common/present/${state?.barcode}?serial=${state?.created_at}`
                                    )
                                  }
                                >
                                  {!state.use_date &&
                                  state.type === 'PRODUCT' &&
                                  state.payment_state !== 'CANCELLED'
                                    ? '배송지 입력'
                                    : '선물 보기'}
                                </Button>
                              ) : (
                                <Button
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    padding: '4px 8px',
                                    cursor: 'pointer',
                                    border: '1px solid var(--black-color)',
                                    backgroundColor: 'var(--white-color)',
                                    color: 'var(--black-color)',
                                    borderRadius: '2px',
                                  }}
                                  onClick={() =>
                                    openPopup(
                                      `/common/present/${state?.barcode}?serial=${state?.created_at}`
                                    )
                                  }
                                >
                                  {!state.use_date ? '사용하기' : '선물 보기'}
                                </Button>
                              )}
                            </div>
                          )}
                        </Flex>

                        {/* 만료일/사용일 */}
                        <Flex vertical>
                          {isSentOrders ? (
                            <Flex gap={8}>
                              <Button
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  padding: '4px 8px',
                                  cursor: state.isCancelAble
                                    ? 'pointer'
                                    : 'default',
                                  border: '1px solid var(--black-color)',
                                  backgroundColor: 'var(--white-color)',
                                  color: 'var(--black-color)',
                                  borderRadius: '2px',
                                  opacity: state.isCancelAble ? 1 : 0.3,
                                }}
                                onClick={() => onCancel(state.present_id)}
                                disabled={!state.isCancelAble}
                              >
                                결제취소
                              </Button>
                            </Flex>
                          ) : (
                            <Text size={16} color={'var(--light-gray-color)'}>
                              {Formatter.unixToDate(
                                state.expired_date,
                                'YYYY.MM.DD'
                              )}{' '}
                              만료
                            </Text>
                          )}
                        </Flex>
                      </div>
                    </div>
                  </div>
                </div>
              );
            },
          },
        ]}
        headerStyle={{ display: 'none' }}
        pagination={false}
        bodyRowStyle={{ padding: 0 }}
      />
    </React.Fragment>
  );
};

export default PresentsListTable;
